import RepoApiRequest from "../../utils/bcc-repo-api-request";
import searchClient from "../../utils/MeiliSearch";
import endpoints from "../repo-api-endpoints";

const read = async (id) => {
  if (id) {
    return await getById(id);
  } else {
    return await getAll();
  }
};

const getById = async (id) => {
  // const result = await apiRequest(GetSubjectByIdQuery, variables);
  // return result.subject;
  // const result = await searchClient.getConcept(id);
  // return result;
  const result = await RepoApiRequest({
    url: endpoints.concept.getById(id),
    method: "GET",
  });
  return result?.data ?? null;
};

const getAll = async () => {
  // const result = await apiRequest(GetSubjectsQuery);
  // return result.subjects;
  const result = await searchClient.getTopLevelSubjectsWithResourceCount(true);
  return result;
};

const readBySlug = async (slug) => {
  // const result = await apiRequest(GetSubjectBySlugQuery, variables);
  // return result.subjects;
  console.warn("[NOT IMPLEMENTED] Subjects readBySlug()");
  return null;
};

const getHierarchy = async () => {
  const result = await RepoApiRequest({
    url: endpoints.concept.getByScheme("subject"),
    method: "GET",
  });
  return result?.data ?? [];
};

const subjectsRepository = { read, readBySlug, getAll, getHierarchy };

export { read, getHierarchy, getAll };
export default subjectsRepository;
